export var CleverSectionGrade;
(function (CleverSectionGrade) {
    CleverSectionGrade["1stGrade"] = "1";
    CleverSectionGrade["2ndGrade"] = "2";
    CleverSectionGrade["3rdGrade"] = "3";
    CleverSectionGrade["4thGrade"] = "4";
    CleverSectionGrade["5thGrade"] = "5";
    CleverSectionGrade["6thGrade"] = "6";
    CleverSectionGrade["7thGrade"] = "7";
    CleverSectionGrade["8thGrade"] = "8";
    CleverSectionGrade["9thGrade"] = "9";
    CleverSectionGrade["10thGrade"] = "10";
    CleverSectionGrade["11thGrade"] = "11";
    CleverSectionGrade["12thGrade"] = "12";
    CleverSectionGrade["PreKindergarten"] = "PreKindergarten";
    CleverSectionGrade["Kindergarten"] = "Kindergarten";
    CleverSectionGrade["PostGraduate"] = "PostGraduate";
    CleverSectionGrade["Other"] = "Other";
})(CleverSectionGrade || (CleverSectionGrade = {}));
//# sourceMappingURL=clever.js.map